$( document ).ready(function() {
    if(typeof(JAK) !== 'undefined'){
        var latitude = $("#map").attr('latitude');
        var longitude = $("#map").attr('longitude');
        var markerUrl = $("#map").attr('markerUrl');
        var znacka = JAK.mel("div");
        var obrazek = JAK.mel("img", {src: markerUrl, style: "max-height: 40px; margin-top: -10px;"});

        znacka.appendChild(obrazek);

        var stred = SMap.Coords.fromWGS84(longitude, latitude);
        var map = new SMap(JAK.gel("map"), stred, 16);
        map.addDefaultLayer(SMap.DEF_BASE).enable();
        map.addDefaultControls();

        var layer = new SMap.Layer.Marker();
        map.addLayer(layer);
        layer.enable();

        var options = {url:znacka};
        var marker = new SMap.Marker(stred, "myMarker", options);
        layer.addMarker(marker);    }

});
